<template>
  <v-card>
    <v-toolbar card dense color="success" style="height: 72px">
      <v-toolbar-title class="white--text text-center w100" style="padding-top: 24px">
        <div>{{ 'app.calendar.calendar' | trans }}</div>
        <div>
          <i aria-hidden="true" class="fa fa-arrow-circle-left pointer" @click="previousDay()"></i>
          {{ date }}
          <i aria-hidden="true" class="fa fa-arrow-circle-right pointer" @click="nextDay()"></i>
        </div>
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <div v-if="listElements.length > 0">
        <v-container fluid pa-0>
          <template v-for="element in listElements">
            <v-layout row>
              <v-flex shrink v-if="element !== null">{{ formatTime(element.start_date) }}</v-flex>
              <v-flex
                  class="pointer event-name"
                  text-left
                  v-if="element !== null"
                  @click="goToCalendarEvent(element)"
                  v-tooltip="element.name"
              >
                {{ element.name }}
              </v-flex>
              <v-divider v-else/>
            </v-layout>
          </template>
        </v-container>
      </div>
      <div v-else>
        <p>{{ 'app.no_data' | trans }}</p>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>

import {SYSTEM_DATE} from "../../utils/dateFormatter";

export default {
  data: () => ({
    date: moment().format('DD.MM.YYYY'),
  }),
  props: {
    calendar_events: {
      type: Array,
    }
  },
  methods: {
    formatTime(dateTime) {
      return moment(dateTime).format("HH:mm");
    },
    goToCalendarEvent(calendarEvent) {
      window.location.href = `/calendar?calendar_event=${calendarEvent.id}`;
    },
    nextDay() {
      this.date = moment(this.date, 'DD.MM.YYYY').add(1, 'day').format('DD.MM.YYYY');
    },
    previousDay() {
      this.date = moment(this.date, 'DD.MM.YYYY').add(-1,'day').format('DD.MM.YYYY');
    },
  },
  computed: {
    listElements() {
      const elements = [];
      const todayEvents = this.calendar_events.filter(ce => moment(ce.start_date, SYSTEM_DATE)
          .format('DD.MM.YYYY') === this.date);
      for (let i = 0; i < todayEvents.length; i++) {
        elements.push(todayEvents[i]);
        if (i < todayEvents.length - 1) {
          elements.push(null);
        }
      }

      return elements;
    }
  }
}
</script>

<style scoped>
.event-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.pointer {
  cursor: pointer;
}

.w100 {
  width: 100%;
}

.pointer {
  cursor: pointer;
}
</style>
